
const digest = '2a92b33badaa4bf9816eb9377ea3733cc1eb95b46c51e01a7d7bd1585d8bb984';
const classes = {"wrapper":"_wrapper_1cc74_1","dateList":"_dateList_1cc74_8","title":"_title_1cc74_17","date":"_date_1cc74_8","activeDate":"_activeDate_1cc74_34","itemsWrapper":"_itemsWrapper_1cc74_46","tableWrapper":"_tableWrapper_1cc74_53"};
const css = `._wrapper_1cc74_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  gap: 7px;
  height: 100%;
}
._wrapper_1cc74_1 ._dateList_1cc74_8 {
  display: flex;
  flex-direction: column;
  border: 1px solid #eaedf4;
  background-color: #ffffff;
  padding: 12px 0;
  width: 200px;
  height: 100%;
}
._wrapper_1cc74_1 ._dateList_1cc74_8 ._title_1cc74_17 {
  font-weight: 600;
  font-size: 14px;
  color: #1665d8;
  padding: 0 12px;
  margin-bottom: 10px;
}
._wrapper_1cc74_1 ._dateList_1cc74_8 ._date_1cc74_8 {
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  padding: 12px;
  border-bottom: 1px solid #eaedf4;
}
._wrapper_1cc74_1 ._dateList_1cc74_8 ._date_1cc74_8:hover {
  background: #edf7ff;
}
._wrapper_1cc74_1 ._dateList_1cc74_8 ._activeDate_1cc74_34 {
  font-weight: 600;
  color: #ffffff;
  background-color: #0B79D9;
}
._wrapper_1cc74_1 ._dateList_1cc74_8 ._activeDate_1cc74_34:hover {
  background: #0B79D9;
}
._wrapper_1cc74_1 ._dateList_1cc74_8 hr {
  background: #eaedf5;
  margin: 0;
}
._wrapper_1cc74_1 ._itemsWrapper_1cc74_46 {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}
._wrapper_1cc74_1 ._itemsWrapper_1cc74_46 ._tableWrapper_1cc74_53 {
  max-height: calc(100% - 320px);
}
._wrapper_1cc74_1 ._itemsWrapper_1cc74_46 ._tableWrapper_1cc74_53 tr:hover td {
  background-color: #eaedf3 !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  